import { NavigateFunction } from 'react-router-dom';

export const formatCurrency = (value: number | bigint): string => {
  return new Intl.NumberFormat('ko-KR', {
    style: 'currency',
    currency: 'KRW',
    minimumFractionDigits: 0,
  }).format(value);
};

export const isUndefinedOrNull = (value: any) => {
  return value === undefined || value === null;
};

export const setDocumentTitle = (subtitle?: string): string => {
  const title = process.env.REACT_APP_NAME ?? '천원경매';
  const dashedSubtitle = subtitle ? ` - ${subtitle}` : '';
  return (document.title = `${title}${dashedSubtitle}`);
};

export const redirectToLoginPage = (navigate: NavigateFunction) => {
  navigate('/auth/login', { replace: true });
};

export const stringToColor = (str: string) => {
  let hash = 0;
  str.split('').forEach((char) => {
    hash = char.charCodeAt(0) + ((hash << 5) - hash);
  });
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    color += value.toString(16).padStart(2, '0');
  }
  return color + '82'; // 50% opacity
};
